import React from "react";
import HeroSection from "../../components/heroSection/HeroSection";
import LoginGuestForm from "../loginGuest/LoginGuestForm";
import heroPhoto from "../../assets/images/photo.jpg";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import NavbarMenu from "../heroSection/NavbarMenu";

export default function LoginPage() {
  const { t } = useTranslation();
  return (
    <>
      {/* <HeroSection
        backgroundImage={heroPhoto}
        title={t("loginguest.heroSection.title")}
        titleHighlight={t("loginguest.heroSection.titleHighlight")}
        showTopbar={false}
        showNavbar={true}
        features={t("loginguest.heroSection.features", { returnObjects: true })}
        showQuoteForm={false}
        showCTAButton={false}
        customHeight="100%"
      /> */}

      <NavbarMenu />
    
      <LoginGuestForm />

      <Footer />
    </>
  );
}